import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import {
  classNames,
  layoutClassNames,
  LayoutClassNameProps,
  surfaceClassNames,
  SurfaceShadow,
  textClassNames,
  TextClassNameProps,
} from './classNames';
import { ButtonRadius, ButtonSize, ButtonVariant } from './Button';

export interface ButtonLinkProps extends LinkProps, LayoutClassNameProps, TextClassNameProps {
  variant?: ButtonVariant;
  size?: ButtonSize;
  outline?: boolean;
  active?: boolean;
  radius?: ButtonRadius;
  shadow?: SurfaceShadow;
}

const ButtonLink = React.forwardRef<HTMLAnchorElement, ButtonLinkProps>(({
  variant = 'primary',
  size,
  outline = false,
  active = false,
  radius = 'default',
  shadow,
  className,
  children,
  margin,
  marginTop,
  marginEnd,
  marginBottom,
  marginStart,
  marginX,
  marginY,
  padding,
  paddingTop,
  paddingEnd,
  paddingBottom,
  paddingStart,
  paddingX,
  paddingY,
  textAlign,
  textColor,
  textDecoration,
  textReset,
  ...props
}, ref) => {
  const variantClass = variant ? `btn-${outline ? 'outline-' : ''}${variant}` : '';

  return (
    <Link
      ref={ref}
      className={classNames(
        'btn',
        variantClass,
        size ? `btn-${size}` : undefined,
        active ? 'active' : undefined,
        radius === 'circle' ? 'rounded-circle' : undefined,
        radius === 'pill' ? 'rounded-pill' : undefined,
        surfaceClassNames({ shadow }),
        textClassNames({
          textColor,
          textDecoration,
          textReset,
        }),
        layoutClassNames({
          margin,
          marginTop,
          marginEnd,
          marginBottom,
          marginStart,
          marginX,
          marginY,
          padding,
          paddingTop,
          paddingEnd,
          paddingBottom,
          paddingStart,
          paddingX,
          paddingY,
          textAlign,
        }),
        className,
      )}
      {...props}
    >
      {children}
    </Link>
  );
});

ButtonLink.displayName = 'ButtonLink';

export default ButtonLink;
